import { VisuallyHidden } from '@mantine/core'
import { useState } from 'react'

import logoImage from '@/assets/images/Logo-light-punchout.png'
import * as styles from '@/styles/OnboardingScreen.css'

import { AccountConfirmationStep } from './AccountConfirmationStep'
import { EmailVerificationStep } from './EmailVerificationStep'
import { SignUpStep } from './SignUpStep'

export function OnboardingScreen() {
  const [activeStep, setActiveStep] = useState(0)
  const [customerInfoUuid, setCustomerInfoUuid] = useState<string | null>(null)
  const [email, setEmail] = useState<string>('')
  const [isAccountSetupComplete, setIsAccountSetupComplete] = useState(false)

  const handleSignUpComplete = (customerInfoId: string, userEmail: string) => {
    setCustomerInfoUuid(customerInfoId)
    setEmail(userEmail)
    setActiveStep(1)
  }

  const handleEmailVerificationComplete = () => {
    setActiveStep(2)
  }

  const handleAccountSetupComplete = () => {
    setIsAccountSetupComplete(true)
  }

  const renderCurrentStep = () => {
    if (activeStep === 0) {
      return <SignUpStep onComplete={handleSignUpComplete} />
    }

    if (activeStep === 1) {
      if (customerInfoUuid && email) {
        return (
          <EmailVerificationStep
            email={email}
            customerInfoId={customerInfoUuid}
            onComplete={handleEmailVerificationComplete}
          />
        )
      }
      return <div>Loading...</div>
    }

    if (activeStep === 2 || isAccountSetupComplete) {
      if (customerInfoUuid) {
        return <AccountConfirmationStep customerInfoUuid={customerInfoUuid} onComplete={handleAccountSetupComplete} />
      }
      return <div>Loading...</div>
    }

    return <div>Loading...</div>
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <VisuallyHidden component="h1">Sign up for Sidekick Platform</VisuallyHidden>
        <header className={styles.header}>
          <img src={logoImage} alt="Sidekick Platform" className={styles.logo} />
        </header>

        <div className={styles.stepperCard}>
          <div className={styles.stepContent}>{renderCurrentStep()}</div>
        </div>
      </div>
    </div>
  )
}
